import { nortadaStorage } from '../../../../../constants/helpers/storage';
import { NORTADA_NEW_CLIENT_PROFILE_STEP } from '../../../../../constants/storage';

export const getInitStep = () => nortadaStorage.getItem(NORTADA_NEW_CLIENT_PROFILE_STEP);
